"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

var _clientAuth = require("@devsta/client-auth");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query GetFilteredOutputs($filter: OutputFilterInput, $limit: Int, $offset: Int, $organisationId: String!) {\n    getFilteredOutputs(filter: $filter, limit: $limit, offset: $offset, organisationId: $organisationId) {\n      count\n      outputs {\n        outputId\n        videoId\n        readableId\n        status {\n          name\n        }\n        aspectRatio\n        isMaster\n        name\n        description\n        tags\n        latestVersion\n        versions {\n          versionNumber\n          dueDate\n          versionId\n          assetId\n        }\n        video {\n          organisationId\n          videoProjectId\n          submittedAt\n          assetIds\n          name\n          creator {\n            userId\n            firstName\n            lastName\n            imageUrl\n          }\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var getFilteredOutputsQuery = (0, _graphqlTag.default)(_templateObject());

function normaliseUserFilter(filter) {
  return filter.USER && filter.USER.includes('ALL') ? _objectSpread({}, filter, {
    USER: void 0
  }) : _objectSpread({}, filter, {
    USER: [_clientAuth.credentials.get().user.userId]
  });
}

var getFilteredOutputs = function getFilteredOutputs(organisationId) {
  return {
    query: getFilteredOutputsQuery,
    module: 'video',
    ignoreCache: true,
    buildVariables: function buildVariables(_ref) {
      var limit = _ref.limit,
          offset = _ref.offset,
          filter = _objectWithoutProperties(_ref, ["limit", "offset"]);

      return {
        filter: normaliseUserFilter(filter),
        limit: limit,
        offset: offset,
        organisationId: organisationId
      };
    }
  };
};

var _default = getFilteredOutputs;
exports.default = _default;